import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import payoutDetailsActions from '../actions/payoutDetails';

function handleApiResponse(store, error, response, onSuccess) {
    if (error) {
        store.dispatch(actions.enableLoadOverLay(false));
        store.dispatch(payoutDetailsActions.alertError('ipmob.internal.server.error'));
        return;
    }
    try {
        if (response.statusCode >= 400 || response.code >= 400) {
            store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
            store.dispatch(actions.enableLoadOverLay(false));
        } else if (response.statusCode >= 200 && response.statusCode < 300) {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        } else {
            store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
            store.dispatch(actions.enableLoadOverLay(false));
        }
    } catch (exp) {
        store.dispatch(payoutDetailsActions.alertError('ipmob.error.process.request'));
        store.dispatch(actions.enableLoadOverLay(false));
    }
}

function submitPayoutDetailsOnboardingMessage(store, { siteName, bankingCountryCode, currency }) {
    request.post(`/${config.url_prefix}/api/submitOnboardingMessage`)
        .send({
            onboardingStatus: 'PAYOUT_DETAILS_CAPTURED',
            additionalFields: {
                site: siteName,
                bankingCountry: bankingCountryCode,
                billingCurrency: currency,
                companyLocation: bankingCountryCode,
            }

        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            handleApiResponse(store, error, response, () => {
                store.dispatch(actions.changeAppState('LISTING_MODEL'));
            });
        });

}

function submitPayoutDetailsForm(store, action) {
    const {siteName, bankingCountryCode, currency} = action.payload;
    // TODO : implement the actual API call to submit payout details
    request.post(`/${config.url_prefix}/api/submitPayoutDetails`)
        .send({
            payload: action.payload
        })
        .set('x-homeaway-site', store.getState().system.siteName)
        .end((error, response) => {
            handleApiResponse(store, error, response, () => {
                submitPayoutDetailsOnboardingMessage(store, { siteName, bankingCountryCode, currency });
            });
        });
}

export default submitPayoutDetailsForm;
